import { ParrotModel } from './parrot.model';
import { parrotsBase64} from './parrots-base64';

export const parrotsData: ParrotModel[] = [
  {
    name: 'beer',
    width: 1280,
    height: 128,
    imageSrc: parrotsBase64.beer,
    numberOfFrames: 10,
  },
  {
    name: 'brazilian',
    width: 1280,
    height: 128,
    imageSrc: parrotsBase64.brazilian,
    numberOfFrames: 10,
  },
  {
    name: 'skiing',
    width: 350,
    height: 25,
    imageSrc: parrotsBase64.skiing,
    numberOfFrames: 10,
  },
  {
    name: 'science',
    width: 300,
    height: 50,
    imageSrc: parrotsBase64.science,
    numberOfFrames: 10,
  },
  {
    name: 'spy',
    width: 1792,
    height: 128,
    imageSrc: parrotsBase64.spy,
    numberOfFrames: 14,
  },
  {
    name: 'parrot',
    width: 350,
    height: 25,
    imageSrc: parrotsBase64.parrot,
    numberOfFrames: 10,
  },
  {
    name: 'cop',
    width: 1280,
    height: 128,
    imageSrc: parrotsBase64.cop,
    numberOfFrames: 10,
  },
  {
    name: 'sloth',
    width: 1280,
    height: 128,
    imageSrc: parrotsBase64.sloth,
    numberOfFrames: 10,
  },
  {
    name: 'rotating',
    width: 455,
    height: 25,
    imageSrc: parrotsBase64.rotating,
    numberOfFrames: 13,
  },
  {
    name: 'gentleman',
    width: 1280,
    height: 128,
    imageSrc: parrotsBase64.gentleman,
    numberOfFrames: 10,
  },
];


